import { PropertyFactory } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfigurationPanels/CustomApiRequestToolConfigurationPanel/JsonSchemaBuilder/properties/factory';
import {
  JsonProperty,
  isStringProperty
} from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfigurationPanels/CustomApiRequestToolConfigurationPanel/JsonSchemaBuilder/properties/types';
import {
  JsonSchema,
  PropertyEditFormData
} from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfigurationPanels/CustomApiRequestToolConfigurationPanel/JsonSchemaBuilder/types';

export const PropertyUtils = {
  createFromFormData: (formData: PropertyEditFormData): JsonProperty => {
    if (formData.type === 'object') {
      return PropertyFactory.createObject(formData.description);
    } else if (formData.type === 'array') {
      const items = PropertyFactory.create('string', 'Array item');
      return PropertyFactory.createArray(formData.description, items);
    } else {
      const newProperty = PropertyFactory.create(formData.type, formData.description);
      if (isStringProperty(newProperty) && formData.enum && formData.enum.length > 0) {
        newProperty.enum = formData.enum;
      }
      return newProperty;
    }
  },

  updateExisting: (existingProperty: JsonProperty, formData: PropertyEditFormData): JsonProperty => {
    if (formData.type === 'object' && existingProperty.type === 'object') {
      // Preserve existing object structure
      return {
        ...existingProperty,
        description: formData.description
      };
    } else if (formData.type === 'array' && existingProperty.type === 'array') {
      // Preserve existing array structure
      return {
        ...existingProperty,
        description: formData.description
      };
    } else if (formData.type === existingProperty.type && formData.type !== 'object' && formData.type !== 'array') {
      // Same primitive type - preserve and update
      const newProperty = {
        ...existingProperty,
        description: formData.description
      };
      if (isStringProperty(newProperty)) {
        if (formData.enum && formData.enum.length > 0) {
          newProperty.enum = formData.enum;
        } else {
          delete newProperty.enum;
        }
      }
      return newProperty;
    } else {
      // Type changed - create fresh property
      return PropertyUtils.createFromFormData(formData);
    }
  },

  updateRequiredFields: (
    parent: JsonSchema | JsonProperty,
    oldKey: string | undefined,
    newKey: string,
    isRequired: boolean
  ): void => {
    if (parent.type !== 'object') return;

    // Handle key changes
    if (oldKey && oldKey !== newKey) {
      parent.required = parent.required.map((req: string) => (req === oldKey ? newKey : req));
    }

    // Handle required field
    if (isRequired) {
      if (!parent.required.includes(newKey)) {
        parent.required.push(newKey);
      }
    } else {
      parent.required = parent.required.filter((req: string) => req !== newKey);
    }
  }
};
